import { inject, Injectable } from '@angular/core';
import { MPKeys } from '@lentau/mpk/shared/constants';
import { CacheMPKService } from './cache-mpk.service';
import { MpkFacade } from '@lentau/mpk/store';

@Injectable({
  providedIn: 'root',
})
export class MPKCacheFacade {
  private cacheMPKService: CacheMPKService = inject(CacheMPKService);
  private mpkFacade: MpkFacade = inject(MpkFacade);

  public init(): void {
    const mpk: MPKeys = this.cacheMPKService.getInitDeliveryMode();
    this.mpkFacade.initMPK(mpk);
  }
}
